module.exports = __webpack_public_path__ + "img/home_hero.aec9ac59.jpg";